export default "__VITE_ASSET__QqZn1rc5__"